import { recordListingEvent } from '../../../../Redux/Actions/recordListingEvent';
import CallLink from '../../../common/CallLink';
import PageLoader from '../../../common/PageLoader';
import { useParams } from 'react-router-dom';
// import { AllPackages, GetOnePackage } from '../../../Redux/actions/HomeAction';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import 'bootstrap/dist/css/bootstrap.css';
import 'react-image-gallery/styles/css/image-gallery.css';
// import Modal from '../../../common/Modal/Modal';
import MapModalForView from '../../../common/Modal/MapModalForView';
import { useTranslation } from 'react-i18next';
import { CommonBanner } from '../CommonBanner';
import { externalUrl } from "../../../../utils/externalUrl";
import { getCarProtectionListing } from '../../../../Redux/Actions/UserAction';

const defaultImages = [
  {
    original: 'assets/images/service-provider/car-protection/banner-b.jpg',
  },
];

const openStatus = ['OPEN', 'مفتوح'];

export default function CarProtectionDetails() {
  const { t } = useTranslation();
  const [expandedPackage, setExpandedPackage] = useState(null);

  var home = useSelector((state) => state.home);
  const DetailList = home?.getCarProtectionList?.[0];
  const dispatch = useDispatch();
  const { carProtectionId } = useParams();
  useEffect(() => { if (carProtectionId) recordListingEvent(carProtectionId, 'carProtection', 'VIEW'); }, [carProtectionId]);
  const [mapModalOpen, setMapModalOpen] = useState(false);
  // const data = { packID: id };

  useEffect(() => {
    if (carProtectionId && carProtectionId !== '')
      dispatch(getCarProtectionListing(carProtectionId));
  }, [carProtectionId, dispatch]);

  const togglePackage = (index) => {
    setExpandedPackage(expandedPackage === index ? null : index);
  };

  if (!DetailList) {
    return (
      <>
        {/* <h2>dsdasdfasdf</h2> */}
        <div
          className="text-center text-warning"
          const
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <PageLoader /> <br />
        </div>
      </>
    );
  }

  console.log('DetailList', DetailList);

  let bannerImages = defaultImages;

  if (DetailList?.businessMedia && DetailList.businessMedia.length > 0) {
    const mediaImages = DetailList.businessMedia
      .filter(
        (mediaItem) =>
          mediaItem?.media?.path &&
          (mediaItem.mediaType === 'MAIN_BANNER' ||
            mediaItem.mediaType === 'BANNER')
      )
      .sort(
        (a, b) =>
          (a.mediaType === 'MAIN_BANNER' ? 0 : 1) -
          (b.mediaType === 'MAIN_BANNER' ? 0 : 1)
      )
      .map((mediaItem) => ({
        original: mediaItem.media.path,
        thumbnail: mediaItem.media.path,
      }));

    if (mediaImages.length > 0) {
      bannerImages = mediaImages;
    }
  }

  const logo = DetailList?.businessMedia?.find(
    (item) => item.mediaType === 'LOGO'
  )?.media?.path;

  const handleOpenMap = () => {
    setMapModalOpen(true);
  };

  const handleCloseMap = () => {
    setMapModalOpen(false);
  };

  //Location Data
  const gpsData =
    typeof DetailList?.gps === 'string'
      ? JSON.parse(DetailList?.gps)
      : DetailList?.gps;
  const lat = parseFloat((gpsData || {}).lat);
  const lng = parseFloat((gpsData || {}).long);

  //Business Calendar
  const businessCalendar =
    typeof DetailList?.calendar === 'string'
      ? JSON.parse(DetailList?.calendar)
      : DetailList?.calendar;
  const now = new Date();
  const currentDay = now
    .toLocaleString('en-us', { weekday: 'long' })
    .toUpperCase(); // "MONDAY"

  const currentTime = now.getHours() * 60 + now.getMinutes();

  const timeToMinutes = (timeStr) => {
    const [time, period] = timeStr.split(' ');
    let [hours, minutes] = time.split(':').map(Number);
    if (period === 'PM' && hours < 12) hours += 12;
    if (period === 'AM' && hours === 12) hours -= 12;
    return hours * 60 + minutes;
  };

  let isOpen = false;
  let nextActionTime = ''; // Time for the next action

  const todaySchedule = (businessCalendar || {})[currentDay];

  if (todaySchedule) {
    const { status, openTime, endTime } = todaySchedule;

    if (status === 'مفتوح' || status === 'OPEN') {
      // "Open" status
      const openMinutes = timeToMinutes(openTime);
      const closeMinutes = timeToMinutes(endTime);

      if (currentTime >= openMinutes && currentTime <= closeMinutes) {
        isOpen = true;
        nextActionTime = endTime; // Display closing time
      } else if (currentTime < openMinutes) {
        isOpen = false;
        nextActionTime = openTime; // Display opening time
      } else {
        isOpen = false;
        nextActionTime = (businessCalendar || {})[currentDay]?.openTime; // Display next day's opening time if closed
      }
    } else {
      isOpen = false;
      nextActionTime = (businessCalendar || {})[currentDay]?.openTime; // Display opening time if closed
    }
  }

  //Social Media Data
  const socialMediaData =
    typeof DetailList?.socialMedia === 'string'
      ? JSON.parse(DetailList?.socialMedia)
      : DetailList?.socialMedia;
  console.log('About Us raw:', DetailList?.about);

  return (
    <div>
      <div class="user-banner">
        <CommonBanner bannerImages={bannerImages} />

        <div class="user-logo-holder">
          <div class="container">
            <div class="user-logo-holder-wrap">
              <div class="row align-items-center justify-content-between">
                <div class="col-12 col-sm-12 col-md-6 mb-3 mb-sm-3 mb-md-0">
                  <div class="row align-items-center">
                    <div class="col-4 col-sm-4 col-md-3">
                      <img
                        src={logo || 'assets/images/user/taxi/user.jpg'}
                        alt=""
                        class="img-fluid user-garage-logo"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = 'assets/images/user/taxi/user.jpg';
                        }}
                      />
                    </div>
                    <div class="col-8 col-sm-8 col-md-auto">
                      <h5 class="mb-3">{DetailList?.carProtectionName}</h5>
                      <ul class="list-inline mb-0 wpm">
                        <li
                          class="list-inline-item"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Calendar"
                        >
                          <a
                            target="_blank"
                            href="javascript:void(0);"
                            data-toggle="modal"
                            data-target="#calendar-modal"
                          >
                            <i class="far fa-calendar-alt"></i>
                          </a>
                        </li>
                        <li
                          class="list-inline-item"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Whatsapp"
                        >
                          <a
                            target="_blank"
                            onClick={() => recordListingEvent(carProtectionId, 'carProtection', 'CONTACT')} href={`https://wa.me/${`${DetailList?.whatsAppNumberCountryCode}${DetailList?.whatsAppNumber}`.replace(/\D/g, '')}`}
                          >
                            <i class="fab fa-whatsapp"></i>
                          </a>
                        </li>
                        <li
                          class="list-inline-item"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Call"
                        >
                          <CallLink
                            target="_blank"
                            onClick={() => recordListingEvent(carProtectionId, 'carProtection', 'CONTACT')} record={DetailList}
                          >
                            <i class="fas fa-phone"></i>
                          </CallLink>
                        </li>
                        <li
                          class="list-inline-item"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Location Map"
                        >
                          <a href="javascript:void(0);" onClick={handleOpenMap}>
                            <i class="fas fa-map-marker-alt"></i>
                          </a>
                          <MapModalForView
                            open={mapModalOpen}
                            handleClose={handleCloseMap}
                            currentLocation={{
                              lat: lat,
                              long: lng,
                            }}
                            address={DetailList?.location}
                          />
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="col-12 col-sm-12 col-md-auto">
                  {(isOpen || (nextActionTime && `${nextActionTime}`.trim() !== '')) && (
                    <p class="mb-3">
                    <span class={isOpen ? 'open-time' : 'close-time'}>
                      {isOpen ? t('Open Now') : t('Close Now')}
                    </span>{' '}
                    |{' '}
                    <span class={isOpen ? 'close-time' : 'open-time'}>
                      {isOpen
                        ? `${t('Closes at')} ${nextActionTime}`
                        : `${t('Open at')} ${nextActionTime}`}
                    </span>
                  </p>
                  )}
                  <ul className="list-inline mb-0">
                    {DetailList?.website && (
                      <li className="list-inline-item">
                        <a
                          href={externalUrl(DetailList?.website)}
                          target="_blank"
                          rel="noreferrer"
                          title="Website"
                        >
                          <i
                            className="fas fa-globe"
                            style={{ fontSize: '24px', color: '#0e76a8', verticalAlign: 'middle' }}
                          ></i>
                        </a>
                      </li>
                    )}
                    {socialMediaData?.INSTAGRAM && (
                      <li className="list-inline-item">
                        <a href={externalUrl(socialMediaData?.INSTAGRAM)} target="_blank" rel="noopener noreferrer">
                          <img
                            src="assets/images/service-provider/instagram.png"
                            alt="Instagram"
                          />
                        </a>
                      </li>
                    )}
                    {socialMediaData?.FACEBOOK && (
                      <li className="list-inline-item">
                        <a href={externalUrl(socialMediaData?.FACEBOOK)} target="_blank" rel="noopener noreferrer">
                          <img
                            src="assets/images/service-provider/facebook.png"
                            alt="Facebook"
                          />
                        </a>
                      </li>
                    )}
                    {socialMediaData?.TWITTER && (
                      <li className="list-inline-item">
                        <a href={externalUrl(socialMediaData?.TWITTER)} target="_blank" rel="noopener noreferrer">
                          <img
                            src="assets/images/service-provider/twitter.png"
                            alt="Twitter"
                          />
                        </a>
                      </li>
                    )}
                    {socialMediaData?.LINKEDIN && (
                      <li className="list-inline-item">
                        <a href={externalUrl(socialMediaData?.LINKEDIN)} target="_blank" rel="noopener noreferrer">
                          <img
                            src="assets/images/service-provider/linkedin.png"
                            alt="Linkedin"
                          />
                        </a>
                      </li>
                    )}
                    {socialMediaData?.YOUTUBE && (
                      <li className="list-inline-item">
                        <a href={externalUrl(socialMediaData?.YOUTUBE)} target="_blank" rel="noopener noreferrer">
                          <img
                            src="assets/images/service-provider/youtube.png"
                            alt="Youtube"
                          />
                        </a>
                      </li>
                    )}
                    {socialMediaData?.SNAPCHAT && (
                      <li className="list-inline-item">
                        <a href={externalUrl(socialMediaData?.SNAPCHAT)} target="_blank" rel="noopener noreferrer">
                          <img
                            src="assets/images/service-provider/snapchat.png"
                            alt="Snapchat"
                          />
                        </a>
                      </li>
                    )}
                    {socialMediaData?.GOOGLEPLUS && (
                      <li className="list-inline-item">
                        <a href={externalUrl(socialMediaData?.GOOGLEPLUS)} target="_blank" rel="noopener noreferrer">
                          <img
                            src="assets/images/service-provider/google-plus.png"
                            alt="Google Plus"
                          />
                        </a>
                      </li>
                    )}
                  </ul>
                </div>
              </div>

              {/* <!-- CALENDAR  MODAL --> */}
              <div
                class="modal fade"
                id="calendar-modal"
                tabindex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title">{t('Timing')}</h5>
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <table class="table table-bordered table-striped">
                        <tbody>
                          <tr>
                            <td scope="col">{t('Day')}</td>
                            <td scope="col">{t('Open')}</td>
                            <td scope="col">{t('Close')}</td>
                          </tr>
                          {[
                            'SUNDAY',
                            'MONDAY',
                            'TUESDAY',
                            'WEDNESDAY',
                            'THURSDAY',
                            'FRIDAY',
                            'SATURDAY',
                          ].map((day) => {
                            const status = openStatus.includes(
                              businessCalendar?.[day]?.status
                            );

                            return status ? (
                              <tr>
                                <td scope="col">{t(day)}</td>
                                <td scope="col">
                                  {businessCalendar?.[day]?.openTime}
                                </td>
                                <td scope="col">
                                  {businessCalendar?.[day]?.endTime}
                                </td>
                              </tr>
                            ) : (
                              <tr>
                                <td scope="col">{t(day)}</td>
                                <td scope="col">{t('Closed')}</td>
                                <td scope="col">{t('Closed')}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-secondary"
                        data-dismiss="modal"
                      >
                        {t('Close')}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="main-content-area">
        <div class="container">
          <h5 className="cav-section-title">{t('About Us')}</h5>
          {DetailList?.about
            ?.split('\n')
            .filter((line) => line.trim() !== '') // remove empty lines
            .map((line, index) => (
              <p key={index}>{line}</p>
            ))}

          {/* [CF-5] Website moved to an icon beside the social icons. */}

          {DetailList?.packages?.length > 0 && (
            <div>
              <h5 className="cav-section-title">{t('Packages')}</h5>
              {DetailList.packages.map((item, i) => (
                <div key={i} style={{ border: '1px solid #e6e8ea', borderRadius: '8px', marginBottom: '8px', overflow: 'hidden', backgroundColor: '#f5f6f7' }}>
                  <div
                    onClick={() => togglePackage(i)}
                    style={{ padding: '9px 16px', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: expandedPackage === i ? '#eceef0' : '#f5f6f7' }}
                  >
                    <div>
                      <h5 style={{ fontWeight: '600', marginBottom: '4px', fontSize: '1rem' }}>{item?.packageName}</h5>
                      <span style={{ color: '#FEBA00', fontWeight: '700', fontSize: '1rem' }}>{item?.price}&nbsp;{item?.currency?.toUpperCase()}</span>
                    </div>
                    <i className={`fas fa-chevron-${expandedPackage === i ? 'up' : 'down'}`} style={{ color: '#f0ad4e', fontSize: '1rem' }}></i>
                  </div>
                  {expandedPackage === i && (
                    <div style={{ padding: '0 20px 15px', borderTop: '1px solid #eee' }}>
                      {item?.description && (
                        <p style={{ color: '#333', fontSize: '0.95rem', lineHeight: '1.6', marginTop: '12px', whiteSpace: 'pre-line' }}>{item.description}</p>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
          <div className="row">
            {/* <table class="table table-bordered table-striped">
              <tr>
                <td scope="col">Category</td>
                <td>{DetailList?.category}</td>
              </tr>
            </table> */}
          </div>
        </div>
      </div>
    </div>
  );
}
